import { render, staticRenderFns } from "./ChatbotMaterialesClase.vue?vue&type=template&id=ddfaa828&scoped=true"
import script from "./ChatbotMaterialesClase.vue?vue&type=script&lang=js"
export * from "./ChatbotMaterialesClase.vue?vue&type=script&lang=js"
import style0 from "./ChatbotMaterialesClase.vue?vue&type=style&index=0&id=ddfaa828&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddfaa828",
  null
  
)

export default component.exports